<template>
  <div class="login-main">
    <nav-bar v-on:sendDefaultAddress="getAddress" :checkpage="page"></nav-bar>
    <section class="review-order-start box-flex">
      <div class="container review-main text-capitalize position-relative review-container-nw box-flex__wrapper">
        <div class="row">
          <div class="col-md-12 p-0">
            <div v-if="cartItemCount > 0">
              <div class="center-card" v-if="isTemplateShow">
                <div class="center-card-box | p-3 top-sticky border-color">
                  <div class="resturant-details | d-flex align-items-center">
                    <div class="rst-nme-add">
                      <h4 class="mt-0">
                        {{ $t("Your Cart")
                        }}<span class="total-items">({{
                          getSubscriptionItem.reduce(
                            (a, c) => a + c.quantity,
                            0
                          )
                        }}
                          {{
                            getSubscriptionItem.reduce(
                              (a, c) => a + c.quantity,
                              0
                            ) > 1
                              ? $t("Items")
                              : $t("Item")
                          }})</span>
                      </h4>
                      <p class="frm-txt">
                        {{ $t("From") }} :
                        <a href="javascript:void(0)" v-if="!restaurantData.id"><skeleton-loader-vue type="string"
                            width="50%" height="20px" /></a>
                        <router-link v-else :to="{
                          name: 'restaurant',
                          params: { restaurant_slug_id: `${slugify(restaurantData.slug)}-rid${restaurantData.id}` }
                        }" class="resst-lnk">{{ restaurantData.name }}</router-link>
                        <!-- <router-link v-else :to="{
                          name: 'restaurant',
                          params: { restaurant_id: encodeBase64(restaurantData.id) },
                        }" class="resst-lnk">{{ this.restaurantData.name }}</router-link> -->
                      </p>
                    </div>
                    <!-- <div class="clen-crt-btn ms-auto">
                      <p class="crt-clnt-txt" @click="cleanCart()">
                        {{ $t("Clear Cart") }}
                      </p>
                    </div> -->
                  </div>
                </div>
                <div class="order-items-main plr15 review-cart-item">
                  <div class="order-item d-flex align-items-center justify-content-between mb-0"
                    v-for="(item, index) in this.getSubscriptionItem" :key="index">
                    <div class="item-heading-main gap-3">
                      <!-- <div class="crt-img crt-img-nw" v-if="item.image && item.item_type != '2'" -->

                      <div class="veg nveg mb-4" v-if="
                        item.item_type == '0' &&
                        $auth.setting.is_cart_image == '0'
                      ">
                        <span></span>
                      </div>
                      <div class="non-veg nveg mb-4" v-if="
                        item.item_type == '1' &&
                        $auth.setting.is_cart_image == '0'
                      ">
                        <span></span>
                      </div>

                      <div class="crt-img crt-img-nw" data-bs-toggle="modal" data-bs-target="#imageModal" v-if="
                        item.image ||
                        item.item_type == '0' ||
                        item.item_type == '1'
                      " :class="item.image == '' || item.image == null ? 'noimg' : ''
                        ">
                        <!-- <img v-if="item.image" :src="item.image" @error="$event.target.src = noImge" /> -->
                        <!-- <div class="free-offer" v-if="freePromocode.is_free_order_item == 1">
                          <p>{{ freePromocode.name_for_promocode + ' ' + $t('for Subscription Only') }}</p>
                        </div> -->
                        <img v-if="
                          item.image && $auth.setting.is_cart_image == '1'
                        " v-lazy="item.image" @error="$event.target.src = noImge"
                          @click="openImagePreview(item.image, item.name)" />

                        <div class="veg veg-non-nw" v-if="
                          item.item_type == '0' &&
                          $auth.setting.is_cart_image == '1'
                        ">
                          <span></span>
                        </div>
                        <div class="non-veg veg-non-nw" v-if="
                          item.item_type == '1' &&
                          $auth.setting.is_cart_image == '1'
                        ">
                          <span></span>
                        </div>
                        <!-- <img src="@/assets/images/non_veg.png" /> -->
                      </div>
                      <div class="item-heading item-heading-nw">
                        <h6 class="item-c-heading">{{ item.name }} :</h6>
                        <p class="item-c-price m-0">
                          <span class="item-price" v-if="item.price != '0'">
                            <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>
                            {{ item.price.toFixed(2) }}</span>
                        </p>
                        <div class="customized customized-primary d-inline-block" v-if="item.selected_type.length > 0">
                          <p class="customized-lable text-start">customized</p>
                          <div class="selected_type flex-column">
                            <div class="selected-main">
                              <p v-for="(subitem, i) in item.selected_type" :key="i">
                                {{ subitem }}
                                <span v-if="
                                  i !=
                                  Object.keys(item.selected_type).length - 1
                                ">,</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="plr15 review-section">
                  <div class="review-boxs">
                    <h6 class="mb-2">{{ $t("special instructions") }}</h6>
                    <input class="form-control mb-0 h50" type="search" :placeholder="instructionPlaceholder"
                      aria-label="instructions" v-model="instructions" />
                  </div>

                  <div class="review-boxs mt-4 promocode-sec border-bottom">
                    <h6 class="mb-2">{{ $t("Subscriptions Type") }}</h6>

                    <div v-if="subscription_type == 1">

                      <p class="mb-2"> {{ $t("Everyday") }}</p>
                      <p class="mx-1 mb-2">{{ subscriptionData.quantity }} {{ $t("Quantity Deliver on Everyday") }}</p>
                    </div>
                    <div v-if="subscription_type == 2">
                      <p class="mb-2">{{ $t("On Interval") }}</p>
                      <!-- {{ intervalDays.isModal ? intervalDays.value : intervalDays.label }} -->


                      <p class="mb-2">{{ intervalDays.quantity }} {{ intervalDays.isModal ?
                        `Quantity Deliver Every
                        ${intervalDays.value}th day` : `Quantity Deliver Every
                        ${intervalDays.value}th day`
                      }}</p>
                      <!-- <p class="mb-2">{{ intervalDays.quantity }} Quantity Deliver {{ intervalDays.label }}</p> -->
                    </div>
                    <div v-if="subscription_type == 3">
                      <p class="mb-2">{{ $t("Custom") }}</p>
                      <div class="card-body">
                        <div class="text-start">
                          <ul class="date-list">
                            <!-- {{ filterDayValue }} -->
                            <li class="date-item" v-if="filterDayValue && filterDayValue.length > 0"
                              v-for="(day, index) in filterDayValue" :key="index">
                              <div class="date-day">{{ day.day.slice(0, 3) }}</div>
                              <div class="date-num">
                                {{ day.quantity }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <ul class="date-list" v-if="subscription_type == 3">
                      <li class="date-item" v-for="(day, index) in day_date_value" :key="index"
                        @click="showCustomModal">
                        <div class="date-day">{{ day.key }}</div>
                        <div class="date-num">
                          {{ day.quantity }}
                        </div>
                      </li>
                    </ul>

                    <a href="javascript:void(0)" @click="SubModals()" class="lnk offer-btn">{{
                      $t("Edit Quantity")
                    }}</a>
                  </div>
                  <div
                    v-if="this.freePromocode.is_free_order_item == 1 && this.subscriptionData && (this.subscriptionData.quantity > 1 || this.getQuantity > 1 || this.customQuantity > 0)">
                    <p class="text-danger">{{ $t('Note : The Free Order Coupon is valid for a single item only and
                      cannot be applied to multiple quantities.') }}</p>
                  </div>
                  <div class=""
                    v-if="this.freePromocode.is_free_order_item == true &&
                      this.subscriptionData && (this.subscriptionData.quantity > 1 || this.getQuantity > 1 || this.customQuantity > 0)">
                    <div class="mt-3">
                      <div class="d-flex justify-content-between">
                        <h6>{{ $t('Use Wallet') }}</h6>
                        <router-link v-if="this.userWallet < this.storeCartDetails.grand_total" :to="{
                          name: 'wallet-payment',
                        }">{{ $t('Recharge Wallet') }}</router-link>
                      </div>


                      <span class="wbalance"><span v-html="$auth.setting.currency" class="currency"></span>{{
                        $auth.user.data.wallet_amount.toFixed(2) }}</span>
                      <div class="" v-if="this.userWallet < this.storeCartDetails.grand_total">
                        <p class="text-danger">
                          {{ $t('Insufficient wallet amount please recharge your wallet') }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="" v-else-if="checkPromocodeApply">
                    <div class="mt-3">
                      <div class="d-flex justify-content-between">
                        <h6>{{ $t('Use Wallet') }}</h6>
                        <router-link v-if="$auth.user.data.wallet_amount < this.storeCartDetails.grand_total" :to="{
                          name: 'wallet-payment',
                        }">{{ $t('Recharge Wallet') }}</router-link>
                      </div>

                      <span class="wbalance"><span v-html="$auth.setting.currency" class="currency"></span>{{
                        $auth.user.data.wallet_amount.toFixed(2) }}</span>
                      <div class="" v-if="$auth.user.data.wallet_amount < this.storeCartDetails.grand_total">
                        <p class="text-danger">
                          {{ $t('Insufficients wallet amount please recharge your wallet') }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="" v-else-if="this.freePromocode.is_free_order_item == false">
                    <div class="mt-3">
                      <div class="d-flex justify-content-between">
                        <h6>{{ $t('Use Wallet') }}</h6>
                        <router-link v-if="$auth.user.data.wallet_amount < this.storeCartDetails.grand_total" :to="{
                          name: 'wallet-payment',
                        }">{{ $t('Recharge Wallet') }}</router-link>
                      </div>

                      <span class="wbalance"><span v-html="$auth.setting.currency" class="currency"></span>{{
                        $auth.user.data.wallet_amount.toFixed(2) }}</span>

                      <div class="" v-if="$auth.user.data.wallet_amount < this.storeCartDetails.grand_total">
                        <p class="text-danger">
                          {{ $t('Insufficient wallet amount please recharge your wallet') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="delivery-options-tabs mt-2 plr15" v-if="shouldShowTabs">
                  <ul class="nav nav-tabs cart_tabs" id="deliveryOptionsTab" role="tablist">
                    <li class="nav-item" role="presentation" v-for="(tab, index) in activeTabs" :key="tab.id">
                      <button class="nav-link"
                        :class="{ 'active': index === 0, 'cart_tab-link': true, [`tab-${index + 1}`]: true }"
                        :id="tab.id" data-bs-toggle="tab" :data-bs-target="'#' + tab.target" type="button" role="tab"
                        :aria-controls="tab.target" :aria-selected="index === 0">
                        {{ tab.label }}
                      </button>
                    </li>
                  </ul>

                  <div class="tab-content" id="deliveryOptionsTabContent">
                    <div class="tab-pane fade" v-for="(tab, index) in activeTabs" :key="tab.target"
                      :class="{ 'show active': index === 0 }" :id="tab.target" role="tabpanel"
                      :aria-labelledby="tab.id">

                      <!-- Time Tab Content -->


                      <!-- Tip Tab Content -->
                      <div v-if="tab.target === 'driver-tip'" class="review-boxs mt-0">
                        <h6 class="mb-2">
                          {{ $t("give tip to driver", { msg: $auth.setting.driver_name })
                          }}
                        </h6>
                        <div class="tip-drivers">
                          <div class="input-group d-inline-flex w-auto"
                            v-for="tip in $auth.setting && $auth.setting.driver_tip">
                            <input type="radio" name="driver_tip" class="visually-hidden" v-model="driver_tip"
                              :id="'tip_' + tip.id" :value="tip.value"
                              @click="getTipValue(tip.value, 'driver_tip', tip.id)" />
                            <label :for="'tip_' + tip.id" class="cust-radio-btn"><span
                                v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{ tip.value
                                }}</label>
                          </div>

                          <div class="input-group w-auto">
                            <input type="radio" name="driver_tip" id="tip_other" class="visually-hidden"
                              :checked="other_driver_tip > 0" :value="other_driver_tip"
                              @click="getTipValue(other_driver_tip, 'other_driver_tip', '')" />
                            <label for="tip_other" class="cust-radio-btn" @click="tipModal"
                              v-if="other_driver_tip == 0">Other</label>
                            <label for="tip_other" class="cust-radio-btn" v-if="other_driver_tip > 0"><span
                                v-html="$auth.setting.currency" class="currency"></span>
                              {{ other_driver_tip }}
                              <i class="fas fa-pen ms-2" @click="tipModal"></i></label>
                          </div>
                        </div>
                      </div>

                      <!-- Instruction Tab Content -->
                      <div v-else-if="tab.target === 'delivery-instruction'" class="review-boxs mt-0">
                        <h6 class="mb-2">
                          {{
                            $t("Delivery Instruction ", { msg: $auth.setting.driver_name })
                          }}
                        </h6>
                        <div class="tip-drivers">
                          <div v-for="instruction in deliveryInstruction" :key="instruction.id">
                            <input type="checkbox" name="delivery_instruction" class="visually-hidden"
                              :id="'delivery_instruction' + instruction.id" :value="instruction.value"
                              v-model="isInstruction[instruction.id]" @click="
                                getDeliveryInstruction(
                                  instruction.value,
                                  'delivery_instruction',
                                  instruction.id
                                )
                                " />
                            <label :for="'delivery_instruction' + instruction.id" class="cust-radio-btn">
                              {{ instruction.value }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Show single section when only one tab would be shown -->

                <div v-else class="review-boxs mt-4">
                  <template v-for="tab in activeTabs">
                    <!-- Time Section -->


                    <!-- Tip Section -->
                    <div v-if="tab.target === 'driver-tip'" class="mt-0">
                      <h6 class="mb-2">{{ $t("Tip", { msg: $auth.setting.driver_name }) }}
                      </h6>
                      <div class="tip-drivers">
                        <div class="input-group d-inline-flex w-auto"
                          v-for="tip in $auth.setting && $auth.setting.driver_tip">
                          <input type="radio" name="driver_tip" class="visually-hidden" v-model="driver_tip"
                            :id="'tip_' + tip.id" :value="tip.value"
                            @click="getTipValue(tip.value, 'driver_tip', tip.id)" />
                          <label :for="'tip_' + tip.id" class="cust-radio-btn"><span
                              v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{ tip.value
                              }}</label>
                        </div>

                        <div class="input-group w-auto">
                          <input type="radio" name="driver_tip" id="tip_other" class="visually-hidden"
                            :checked="other_driver_tip > 0" :value="other_driver_tip"
                            @click="getTipValue(other_driver_tip, 'other_driver_tip', '')" />
                          <label for="tip_other" class="cust-radio-btn" @click="tipModal"
                            v-if="other_driver_tip == 0">Other</label>
                          <label for="tip_other" class="cust-radio-btn" v-if="other_driver_tip > 0"><span
                              v-html="$auth.setting.currency" class="currency"></span>
                            {{ other_driver_tip }}
                            <i class="fas fa-pen ms-2" @click="tipModal"></i></label>
                        </div>
                      </div>
                    </div>

                    <!-- Instruction Section -->
                    <div v-else-if="tab.target === 'delivery-instruction'" class="mt-0">
                      <h6 class="mb-2">{{ $t("Instruction ", {
                        msg: $auth.setting.driver_name
                      }) }}</h6>
                      <div class="tip-drivers">
                        <div v-for="instruction in deliveryInstruction" :key="instruction.id">
                          <input type="checkbox" name="delivery_instruction" class="visually-hidden"
                            :id="'delivery_instruction' + instruction.id" :value="instruction.value"
                            v-model="isInstruction[instruction.id]" @click="
                              getDeliveryInstruction(
                                instruction.value,
                                'delivery_instruction',
                                instruction.id
                              )
                              " />
                          <label :for="'delivery_instruction' + instruction.id" class="cust-radio-btn">
                            {{ instruction.value }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="review-boxs mt-4"
                  v-if="this.isPickupDelivery == 1 && this.$auth.setting && this.$auth.setting.is_active_porter == true && this.$auth.setting.porter_delivery_charges == true && this.showPorterChrages == true">
                  <h6 class="mb-3 text-start">{{ $t("Select Your Delivery Option") }}</h6>
                  <div class="options-grid">
                    <div v-for="(charge, index) in porterCharges" :key="index" class="option-card"
                      :class="['card', { 'active-border': activePorterIndex === index }]"
                      @click="togglePorterSelection(charge.amount, index)">
                      <input type="radio" class="visually-hidden" :id="'tip_' + index"
                        :checked="seletectedPorter === charge.amount" />
                      <label :for="'tip_' + index"
                        :class="['cust-porter-btn', { 'active-border': activePorterIndex === index }]">
                        <div class="card-body text-center vehicle-name">
                          <label class="card-title">{{ charge.name }}</label>
                          <p class="card-text">
                            <span v-html="$auth.setting && $auth.setting.currency"></span>{{ charge.amount }}
                          </p>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>


                <div class="review-boxs mt-4 d-none">
                  <div class="billing-data custom-checkbox" v-if="
                    $auth.setting &&
                    $auth.setting.contact_less_delivery &&
                    (isPickupDelivery == 1 || isPickupDelivery == -1) &&
                    $auth.setting.is_pickup_enable == true &&
                    $auth.setting.contact_less_delivery == 1
                  ">
                    <div class="d-flex justify-content-between align-items-center form-group">
                      <h6>{{ $t("Opt in for No-contact Delivery") }}</h6>
                      <input class="form-group" id="cntctdelivery" type="checkbox" true-value="1" false-value="0"
                        v-model="contactDelivery" />
                      <label class="form-check-label" for="cntctdelivery"></label>
                    </div>
                    <p class="pcolor">
                      {{
                        this.$auth.setting.terminology &&
                        $auth.setting.terminology[0].contact_less_delivery_text
                      }}
                    </p>
                  </div>
                </div>


                <div id="billing-data" class="billing-data p-3">
                  <h6 class="mb-3">{{ $t("Billing Details") }}</h6>
                  <ul>
                    <li class="d-flex justify-content-between">
                      <span v-if="storeCartDetails.items_tax_total > '0.00'">
                        {{ $t("Item Total") }}
                        <i v-b-tooltip.hover.right.nofade.html.v-secondary="'Included item ' +
                          ($auth.setting.terminology &&
                            $auth.setting.terminology[0].tax_name !== ''
                            ? $auth.setting.terminology[0].tax_name
                            : '') +
                          ' ' +
                          $auth.setting.currency +
                          ' ' +
                          storeCartDetails.items_tax_total
                          " class="fa fa-info-circle" aria-hidden="true"></i></span>
                      <span v-else>{{ $t("Item Total") }}</span>
                      <span><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                        storeCartDetails && storeCartDetails.subtotal.toFixed(2) }}</span>
                      <!-- <span><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                        getTotalItemAmount() }}</span> -->
                    </li>

                    <li
                      v-if="promocode && storeCartDetails.promo_code && storeCartDetails.promo_code.is_free_delivery == true && isPickupDelivery == 1"
                      class="d-flex justify-content-between">
                      {{ $t("Delivery Charges") }}
                      <div>
                        <span class="text-decoration-line-through">
                          <span v-html="$auth.setting.currency" class="currency"></span>{{
                            storeCartDetails.delivery_charge }}</span>
                        <span class="text-success mx-1">{{ $t("Free") }}</span>
                      </div>
                    </li>

                    <!-- Regular delivery charges -->
                    <li v-else-if="isPickupDelivery == 1" class="d-flex justify-content-between">
                      {{ $t("Delivery Charges") }}
                      <span>
                        <span v-html="$auth.setting.currency" class="currency"></span>{{
                          storeCartDetails.delivery_charge }}
                      </span>
                    </li>

                    <li class="d-flex justify-content-between" v-if="others_fees > 0">
                      <span>
                        {{ $t("Taxes & Other Fees") }}
                        <i class="fa fa-info-circle" aria-hidden="true" @click="otherFeesModal()"></i></span>
                      <span><span v-html="$auth.setting.currency" class="currency"></span>{{ $formatPrice(others_fees)
                      }}</span>
                    </li>

                    <li class="d-flex justify-content-between" v-if="driver_tip > 0 && isPickupDelivery == 1">
                      {{ $t("Driver Tip")
                      }}<span><span v-html="$auth.setting.currency" class="currency"></span>{{ driver_tip }}</span>
                    </li>

                    <li class="d-flex justify-content-between" v-if="new_driver_tip > 0 && isPickupDelivery == 1">
                      {{ $t("Driver Tip")
                      }}<span><span v-html="$auth.setting.currency" class="currency"></span>{{ other_driver_tip
                      }}</span>
                    </li>

                    <li class="d-flex justify-content-between discount" v-if="promoDiscount && promoCodeType != 5">
                      {{ $t("Discount") }}
                      <span>- <span v-html="$auth.setting.currency" class="currency"></span>{{
                        parseFloat(promoDiscount).toFixed(2) }}</span>
                    </li>
                    <li class="d-flex justify-content-between promo-discount" v-if="promoCashback">
                      {{ $t("Cashback")
                      }}<span><span v-html="$auth.setting.currency" class="currency"></span>{{ promoCashback.toFixed(2)
                      }}</span>
                    </li>

                    <li class="d-flex justify-content-between bold">
                      {{ $t("To Pay")
                      }}<span><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                        storeCartDetails && storeCartDetails.grand_total.toFixed(2) }}</span>
                    </li>
                  </ul>
                  <div class="svprc">
                    <p class="d-flex justify-content-between"
                      v-if="storeCartDetails.saved_amount > 0 || promoDiscount > 0 || promoCashback > 0 || deliveryCharge > 0">
                      {{ $t("You Saved") }}
                      <span><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                        storeCartDetails && storeCartDetails.saved_amount.toFixed(2)
                      }}</span>
                    </p>
                  </div>
                  <li v-if="isPickupDelivery == 1 || isPickupDelivery == 0">
                    <p class="pcolor">
                      {{
                        $auth.setting &&
                        $auth.setting.terminology &&
                        $auth.setting.terminology[0].cart_info_text
                      }}
                    </p>
                  </li>
                </div>
                <div class="delivery-address plr15">
                  <!-----------Radio Delivery and pickup --------------->
                  <div class="d-flex align-items-center justify-content-between mb-3 gap-2">
                    <!-----------<div class="delivery-pickup-main d-flex align-items-center mb-1" v-if="
                      $auth.setting &&
                      $auth.setting.is_pickup_enable == true">
                      <div class="delivery-pickup-lnk me-2">
                        <div class="switch" id="switch">
                          <input name="radio" @click="getDelivery('1')" type="radio" value="1" id="delivery"
                            :checked="isPickupDelivery == 1" />
                          <label for="delivery">{{ $t("Delivery") }}</label>
                          <input name="radio" @click="getDelivery('0')" type="radio" value="0" id="pickup"
                            :checked="isPickupDelivery == 0" />
                          <label for="pickup" class="right">{{
                            $auth.setting.terminology[0].takeaway_text
                              ? $auth.setting.terminology[0].takeaway_text
                              : "Takeaway"
                          }}</label>
                          <span class="swtact" :class="this.rightClass || {
                            right: ['0'].includes(isPickupDelivery),
                          }
                            " aria-hidden="true"></span>
                        </div>
                      </div>
                    </div> --------------->
                    <!-----------Radio Delivery and pickup --------------->
                    <!-- <h6 class="mb-0">-->
                    <div class="delivery-nw-section" v-if="
                      isPickupDelivery == 1 ||
                      isPickupDelivery == -1 &&
                      $auth.setting.is_pickup_enable == true
                    ">
                      <span v-if="primaryAddress && primaryAddress.clarification">{{
                        $t("Delivery To " + primaryAddress.clarification)
                      }}</span>
                      <div v-if="
                        Object.keys(primaryAddress).length == 0 ||
                        primaryAddress.deliveryAddress == ''
                      " class="addaddrs">
                        <router-link :to="{ name: 'add-address' }">{{
                          $t("Add New Address")
                        }}</router-link>
                      </div>

                      <div v-if="addressList" class="chng-addrs">
                        <a href="javascript:void(0)" @click="deliveryModalOpen" class="lnk">{{ $t("Change Address")
                        }}</a>
                      </div>
                      <p>{{ primaryAddress.deliveryAddress }}</p>
                    </div>
                    <!-- v-if="$auth.setting.is_pickup_enable == 'true' || isPickupDelivery == 0 || isPickupDelivery == -1" -->
                    <div v-else class="pckup-addr-cls">
                      <span class="pickup-txt">{{ $auth.setting && $auth.setting.terminology[0].takeaway_text }} {{
                        $t("from") }} {{ restaurantData.name }}</span>
                      <div class="map-add-cls">
                        <a :href="'https://www.google.com/maps?saddr=' +
                          latitude +
                          ',' +
                          longitude +
                          '&daddr=' +
                          restaurantLat +
                          ',' +
                          restaurantLong
                          " target="_blank">></a>
                      </div>
                      <div class="pic-cls-con">
                        <p v-bind:title="restaurantData.address">
                          {{ this.restaurantData.address }}
                        </p>
                      </div>
                    </div>

                    <!-- <div v-if="isPickupDelivery == 0" class="pckup-addr-cls">
                      <span class="pickup-txt">{{ $t("Pickup from") }}</span>
                      <div class="map-add-cls">
                        <a :href="'https://www.google.com/maps?saddr=' +
                          latitude +
                          ',' +
                          longitude +
                          '&daddr=' +
                          restaurantLat +
                          ',' +
                          restaurantLong
                          " target="_blank">></a>
                      </div>
                      <div class="pic-cls-con">
                        <p v-bind:title="restaurantData.location_address">
                          {{ this.restaurantData.location_address }}
                        </p>
                      </div>
                    </div> -->
                  </div>



                  <div class="full-btn">
                    <a @click="redirectBillingData()" class="btn billing-btn view-dtail-cls">
                      <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                        storeCartDetails && storeCartDetails.grand_total.toFixed(2)
                      }}<span class="txtline">{{ $t("View Bill Details") }}</span>
                    </a>

                    <a v-if="freePromocode.is_free_order_item == 1" :href="canSubscribe ? 'javascript:void(0);' : null"
                      class="prcc-cls-blr" :class="{ 'disabled-link': !canSubscribe }"
                      @click="canSubscribe ? processToPay() : null">
                      {{ $t("Subscribe") }}
                    </a>

                    <a v-else-if="this.restaurantData.minimum_admin_commision == null &&
                      storeCartDetails.grand_total <
                      parseInt(this.restaurantData.minimum_order_value)
                    " href="javascript:void(0);" class="prcc-cls">{{ $t("Minimum Item Total")
                    }}<span v-html="$auth.setting.currency" class="currency"></span>{{
                        this.restaurantData.minimum_order_value }}</a>

                    <a v-else
                      :href="$auth.user.data.wallet_amount >= storeCartDetails.grand_total && 'javascript:void(0);'"
                      class="prcc-cls-blr" :class="{
                        'disabled-link': $auth.user.data.wallet_amount < storeCartDetails && storeCartDetails.grand_total
                      }"
                      @click="$auth.user.data.wallet_amount >= storeCartDetails.grand_total ? processToPay() : null">
                      {{ $t("Subscribe") }}
                    </a>



                  </div>
                </div>
              </div>
              <!--------All Promocode Modal start---------->
              <div class="modal fade order-placed" id="promocodeModal" tabindex="-1"
                aria-labelledby="promocodeModallabel" aria-hidden="true" ref="promocodeModalRef" style="z-index: 9999">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4 class="modal-title" id="filterLabel">
                        {{ $t("Promocode") }}
                      </h4>
                      <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body text-center" v-if="promoCodes.length > 0">
                      <div class="order-item d-flex align-items-center justify-content-between"
                        v-for="(offers, index) in this.promoCodes" :key="index">
                        <div class="d-flex align-items-start">
                          <div class="smallimg-squre">
                            <img v-lazy="offers.image" />
                          </div>
                          <div class="order-data ms-3 d-flex align-items-start justify-content-between w-100">
                            <div class="orders-status-main">
                              <h6 class="mb-0">{{ offers.name }}</h6>
                              <p class="mt-1" :id="'shortdec' + offers.id" style="display: block">
                                {{ offers.description.substring(0, 54) }}
                                <a v-if="
                                  offers.description && offers.description.length > 54
                                " href="javascript:void(0)" @click="readMore(offers.id)" class="readmore">...more</a>
                              </p>
                              <p :id="'moredesc' + offers.id" style="display: none">
                                {{ offers.description }}
                                <a href="javascript:void(0)" @click="readMore(offers.id)" class="readless">...less</a>
                              </p>
                              <div class="promocode mt-2">
                                <p>
                                  {{ $t("Code") }}:
                                  <span class="m-promocode">{{
                                    offers.code
                                  }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a class="cart-btn" @click="applyPromocode(offers.code, offers.id)">{{
                          $t("Apply")
                        }}</a>
                      </div>
                    </div>
                    <!-- <div v-else class="modal-body text-center"><p>{{$t('No Offers Available')}}</p></div> -->
                    <div v-else class="home-res-not-found my-auto">
                      <div class="nostr-img-cls">
                        <!-- <img src="@/assets/images/no_promocode.png" />               -->
                        <svg width="150" height="150" viewBox="0 0 150 150" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <rect x="24" y="130" width="7" height="1" rx="0.5" fill="#FF8300" />
                          <rect x="34" y="130" width="86" height="1" rx="0.5" fill="#FF8300" />
                          <rect x="122" y="130" width="4" height="1" rx="0.5" fill="#FF8300" />
                          <path
                            d="M80 84.5H106C108.485 84.5 110.5 86.5147 110.5 89V130.5H75.5V89C75.5 86.5147 77.5147 84.5 80 84.5Z"
                            stroke="#FF8300" />
                          <path
                            d="M47 58.5H93C95.4853 58.5 97.5 60.5147 97.5 63V130.5H42.5V63C42.5 60.5147 44.5147 58.5 47 58.5Z"
                            fill="white" stroke="#FF8300" />
                          <line x1="34.3537" y1="49.7104" x2="40.8333" y2="56.19" stroke="#FF8300"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <line x1="46.8974" y1="44.6124" x2="44.5257" y2="53.4636" stroke="#FF8300"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <line x1="0.5" y1="-0.5" x2="9.66346" y2="-0.5"
                            transform="matrix(0.965926 -0.258819 -0.258819 -0.965926 28 62.5439)" stroke="#FF8300"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <line x1="51.5" y1="91.5" x2="75.5" y2="91.5" stroke="#FF8300" stroke-width="3"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <line x1="51.5" y1="101.5" x2="65.5" y2="101.5" stroke="#FF8300" stroke-width="3"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <line x1="51.5" y1="83.5" x2="84.5" y2="83.5" stroke="#FF8300" stroke-width="3"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <rect x="102" y="65" width="19" height="1" rx="0.5" fill="#FF8300" />
                          <rect x="12" y="95" width="19" height="1" rx="0.5" fill="#FF8300" />
                          <rect x="109" y="77" width="19" height="1" rx="0.5" fill="#FF8300" />
                          <circle cx="137.828" cy="107.828" r="2.32787" stroke="#FF8300" />
                          <circle cx="77.8279" cy="47.8279" r="2.32787" stroke="#FF8300" />
                          <circle cx="127.828" cy="47.8279" r="2.32787" stroke="#FF8300" />
                          <circle cx="17.8279" cy="117.828" r="2.32787" stroke="#FF8300" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M16.1986 70.3995C15.9777 70.1787 15.6196 70.1787 15.3988 70.3995L13.7991 71.9992L12.1994 70.3995C11.9785 70.1787 11.6204 70.1787 11.3995 70.3995C11.1787 70.6204 11.1787 70.9785 11.3995 71.1994L12.9992 72.7991L11.3995 74.3987C11.1787 74.6196 11.1787 74.9777 11.3995 75.1986C11.6204 75.4194 11.9785 75.4194 12.1994 75.1986L13.7991 73.5989L15.3988 75.1986C15.6196 75.4194 15.9777 75.4194 16.1986 75.1986C16.4195 74.9777 16.4195 74.6196 16.1986 74.3987L14.5989 72.7991L16.1986 71.1994C16.4195 70.9785 16.4195 70.6204 16.1986 70.3995Z"
                            fill="#FF8300" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M56.6678 34.6119C56.8346 34.3478 56.7558 33.9985 56.4918 33.8317L54.5793 32.6232L55.7877 30.7107C55.9546 30.4467 55.8758 30.0973 55.6117 29.9305C55.3477 29.7636 54.9984 29.8424 54.8315 30.1065L53.623 32.019L51.7106 30.8105C51.4465 30.6437 51.0972 30.7225 50.9303 30.9865C50.7635 31.2506 50.8423 31.5999 51.1063 31.7667L53.0188 32.9752L51.8104 34.8877C51.6435 35.1518 51.7223 35.5011 51.9864 35.6679C52.2504 35.8348 52.5997 35.756 52.7666 35.4919L53.9751 33.5794L55.8875 34.7879C56.1516 34.9548 56.5009 34.876 56.6678 34.6119Z"
                            fill="#FF8300" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M143.787 71.3934C143.787 71.0811 143.534 70.8279 143.221 70.8279L140.959 70.8279L140.959 68.5656C140.959 68.2532 140.706 68 140.393 68C140.081 68 139.828 68.2532 139.828 68.5656L139.828 70.8279L137.566 70.8279C137.253 70.8279 137 71.0811 137 71.3934C137 71.7058 137.253 71.959 137.566 71.959L139.828 71.959L139.828 74.2213C139.828 74.5337 140.081 74.7869 140.393 74.7869C140.706 74.7869 140.959 74.5337 140.959 74.2213L140.959 71.959L143.221 71.959C143.534 71.959 143.787 71.7058 143.787 71.3934Z"
                            fill="#FF8300" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M108.787 21.3934C108.787 21.0811 108.534 20.8279 108.221 20.8279L105.959 20.8279L105.959 18.5656C105.959 18.2532 105.706 18 105.393 18C105.081 18 104.828 18.2532 104.828 18.5656L104.828 20.8279L102.566 20.8279C102.253 20.8279 102 21.0811 102 21.3934C102 21.7058 102.253 21.959 102.566 21.959L104.828 21.959L104.828 24.2213C104.828 24.5337 105.081 24.7869 105.393 24.7869C105.706 24.7869 105.959 24.5337 105.959 24.2213L105.959 21.959L108.221 21.959C108.534 21.959 108.787 21.7058 108.787 21.3934Z"
                            fill="#FF8300" />
                        </svg>
                        <h6>{{ $t("No Offers Available") }}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--------All Promocode Modal End---------->
            </div>
            <div v-else class="order-items-main">
              <div class="center-card | d-flex align-items-center justify-content-center">
                <div class="center-card-box | p-3">
                  <div class="full-btn text-center">
                    <div class="crt-img-cls">
                      <img v-lazy="require('@/assets/images/empty_cart.png')" class="img-fluid d-inline-block" />
                    </div>
                    <p class="empty-cart my-4">{{ $t("Cart Empty") }}</p>
                    <a href="javascript:void(0)" class="w-auto d-inline-flex mx-auto" @click="goToHome()">{{ $t("Go
                      Back")}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- porterl delivery charges modal -->
        <div class="modal texes-modal fade" id="portalModal" tabindex="-1" aria-labelledby="portalModallabel"
          aria-hidden="true" ref="portalModalRef" data-bs-backdrop="static" data-bs-keyboard="false"
          style="z-index: 9999">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content texes-modal-content py-4 billing-data">
              <h6 class="d-flex justify-content-center">
                {{ $t("Select delivery Charges") }}
              </h6>
              <ul class="mt-4 overflow-auto">
                <li class="tip-drivers d-flex justify-content-between" v-for="(charge, index) in porterCharges"
                  :key="index">
                  <label :for="'tip_' + index" class="">{{
                    charge.vehicle_name
                  }}</label>
                  <input type="radio" class="visually-hidden" v-model="seletectedPorter" :id="'tip_' + index"
                    :value="charge.minor_amount"
                    @click="getPorterValue(charge.minor_amount, charge.vehicle_name, index)" />
                  <label :for="'tip_' + index" class=""><span v-html="$auth.setting && $auth.setting.currency"
                      class="currency"></span>
                    {{
                      (charge.minor_amount / 100).toFixed(2)
                    }}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- porterl delivery charges modal -->

        <!-- Driver Tip Modal-->
        <div class="modal fade" id="driverTipModal" tabindex="-1" aria-labelledby="driverTipModalLabel"
          aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div class="modal-dialog">
            <div class="modal-content h-auto border-0">
              <div class="modal-body">
                <h4>Drivers Tip</h4>
                <p class="mb-3">Enter amount of tip you want to give...</p>
                <input type="text" class="form-control" id="tripValue" v-model="other_driver_tip" placeholder="Amount"
                  @keypress="floatNumberOnly($event)"
                  oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                  minlength="1" maxlength="5" />
                <div class="d-flex align-items-center justify-content-end mt-4">
                  <a href="javascript:void(0)" class="btn me-4" @click="cancelTipModal('')">Cancel</a>
                  <a href="javascript:void(0);" class="btn btn--primary cncl-tip" @click="closeTipModal">Add
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Driver Tip Modal-->

        <!--  Other tex packagine and convince and gst modal-->

        <div class="modal texes-modal fade" id="otherFeesModal" tabindex="-1" aria-labelledby="otherFeesModallabel"
          aria-hidden="true" ref="otherFeesModalRef" style="z-index: 9999">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content texes-modal-content py-4 billing-data p-3">
              <h6 class="d-flex justify-content-center">
                {{ $t("Taxes & Other Fees") }}
              </h6>
              <ul class="mt-4 overflow-auto">
                <li class="d-flex justify-content-between" v-if="storeCartDetails.tax &&
                  this.$auth.setting &&
                  (this.$auth.setting.included_tax == true ||
                    this.$auth.setting.included_tax == 'Yes')">

                  {{
                    this.$auth.setting &&
                    this.$auth.setting.terminology &&
                    this.$auth.setting.terminology[0].tax_name
                  }}({{ restaurantDetails.data && restaurantDetails.data.service_tax }}%)
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    storeCartDetails.tax
                  }}</span>
                </li>

                <li class="d-flex justify-content-between" v-if="storeCartDetails.packaging_charge > 0">
                  <span>{{
                    this.$auth.setting.terminology[0].packaging_fee
                      ? this.$auth.setting.terminology[0].packaging_fee
                      : "Packaging Fees "
                  }}</span>
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    storeCartDetails.packaging_charge.toFixed(2) }}</span>
                </li>

                <li class="d-flex justify-content-between" v-if="storeCartDetails.convince_charge > 0">
                  {{
                    this.$auth.setting.terminology[0].convenience_fee
                      ? this.$auth.setting.terminology[0].convenience_fee
                      : "Convenience Fees"
                  }}
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    storeCartDetails.convince_charge.toFixed(2) }} </span>
                </li>

                <li
                  v-if="promocode && storeCartDetails.promo_code && storeCartDetails.promo_code.is_free_delivery == true && isPickupDelivery == 1 && this.$auth.setting.is_delivery_charge_tax_enable == true"
                  class="d-flex justify-content-between">
                  {{ "Delivery Charges" }} {{ this.$auth.setting && this.$auth.setting.terminology[0].tax_name }} {{
                    `(${this.$auth.setting && this.$auth.setting.delivery_charge_tax}%)` }}
                  <div>
                    <span class="text-decoration-line-through">
                      <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                        storeCartDetails && storeCartDetails.additional_tax_on_delivery_charges }}</span>
                    <span class="text-success mx-1">{{ $t("Free") }}</span>
                  </div>
                </li>

                <!-- Regular delivery charges  tax -->
                <li
                  v-else-if="isPickupDelivery == 1 && this.$auth.setting && this.$auth.setting.is_active_porter == false && this.$auth.setting.is_delivery_charge_tax_enable == true"
                  class="d-flex justify-content-between">
                  {{ "Delivery Charges" }} {{ this.$auth.setting && this.$auth.setting.terminology[0].tax_name }} {{
                    `(${this.$auth.setting && this.$auth.setting.delivery_charge_tax}%)` }}
                  <span>
                    <span v-html="$auth.setting.currency" class="currency"></span>{{
                      storeCartDetails && storeCartDetails.additional_tax_on_delivery_charges }}
                  </span>
                </li>

                <!-- v-if="this.restaurantData.minimum_admin_commision !== 0 && this.restaurantData.minimum_admin_commision !== null && this.adminComissionValue !== 0" -->
                <li class="d-flex justify-content-between" v-if="storeCartDetails.short_order_fee > 0">
                  {{ "Short Order fee" }}
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    storeCartDetails.short_order_fee.toFixed(2) }} </span>
                </li>

              </ul>
              <div class="modal-footer">
                <div class="full-btn mt-4 bottom-stiky border-0 w-100" @click="closeTexModal">
                  <button>{{ $t("Got it") }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  Other tex packagine and convince and gst modal-->

        <!-- image modal preview start-->
        <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">
                  {{ itemName }}
                </h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <img v-if="selectedImage" v-lazy="selectedImage" class="img-fluid" alt="Image Preview" />
            </div>
          </div>
        </div>
        <!-- image modal preview end-->
        <div class="modal fade order-img" data-backdrop="static" data-keyboard="false" id="imgOpen" tabindex="-1"
          aria-labelledby="imgOpen" aria-hidden="true" ref="imgOpenModal" style="z-index: 9999">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content order-img-modal">
              <div class="modal-body text-center">
                <a data-bs-dismiss="modal" class="lnk crosclose">X</a>
                <img :src="imageUrl" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <subscription-modal v-if="subscriptionModalOPen" :type="subscription_type" :closeDays="closedDays"
      @subscriptionModalClose="closeSubscriptionModal" @selectedData="manageSubscriptiopData"></subscription-modal>
    <track-order v-if="isOrderSuccess" :subscription_type="subscription_type" :iswallet="iswallet"></track-order>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import NavBar from "../components/NavBar.vue";
import DeliveryTime from "../components/DeliveryTime.vue";
import Footer from "../components/Footer.vue";
import moment from "moment";
import VueSkeletonLoader from "skeleton-loader-vue";
import noImge from "@/assets/images/place_holder.png";
import Subscription from './Subscription.vue';
import SubscriptionModal from './SubscriptionModal.vue';
import TrackOrder from '../components/TrackOrder.vue';
import { handleApiError } from "../helper/helper";


export default {
  components: {
    NavBar,
    DeliveryTime,
    Footer,
    "skeleton-loader-vue": VueSkeletonLoader,
    Subscription,
    TrackOrder,
    SubscriptionModal
  },
  data() {
    return {
      moment: moment,
      restaurantData: "",
      filterDayValue: [],
      address: "",
      gstMaxtax: 0,
      cartItemCount: 1,
      promocode: "",
      promo_code_type: "",
      promoError: "",
      promoDiscount: 0,
      promoSuggetion: "",
      isPromocodeApply: false,
      isPopup: true,
      promoCashback: 0,
      promoCodeType: 0,
      contactDelivery: 0,
      onpageDelivery: 0,
      place_order_parameter: {},
      shiping_id: "",
      coupon_id: "",
      instructions: "",
      restaurantId: 0,
      scheduleDateTime: {},
      promoCodes: [],
      latitude: "",
      longitude: "",
      restaurantLat: "",
      restaurantLong: "",
      page: "review_page",
      isAsapEnable: false,
      timeFormat: "HH:mm:ss",
      isRestaurantClosed: false,
      isSameDayDelivery: false,
      is_btn_spinner: false,
      images: [],
      orderImagesId: "",
      loading: false,
      deliveryCharge: 0.0,
      noImge,
      instructionPlaceholder: "",
      applyPromoCodeResult: {},
      isDunzoAlert: false,
      packagingCharge: 0,
      driver_tip: 0,
      other_driver_tip: "",
      new_driver_tip: 0,
      is_driver_tip: false,
      radioCounts: 0,
      tipsClick: [],
      convince_charge: 0,
      rightClass: "",
      isTemplateShow: false,
      parsedDriverTips: [],
      selectedImage: null,
      itemName: "",
      // area_not_available: true,
      reason: null,
      imageUrl: "",
      is_other_Tip: false,
      others_fees: "",
      autoApplyCode: true,
      deliveryInstruction: [],
      Instruction: [],
      isInstruction: {},
      time_slots: 0,
      emailPromptDismissed: false,
      selectedIndex: null,
      deliveryChargeTax: 0,
      adminComissionValue: 0,
      porterCharges: [],
      seletectedPorter: 0,
      seletectedPorterIndex: null,
      activePorterIndex: null,
      showPorterChrages: true,
      getPreAddress: '',
      storeCartDetails: '',
      itemsDetails: '',
      deliveryType: '1',
      deliveryInstructionValues: '',
      cart_id: '',
      formattedItems: '',
      subscriptionModalOPen: false,
      isOrderSuccess: false,
      subscription_type: 0,
      interval: 0,
      custom_days: [],
      subscriptionData: "",
      intervalDays: "",
      closedDays: '',
      getQuantity: 0,
      is_check_custom: true,
      customQuantity: 0,
      freePromocode: "",
      checkPromocodeApply: '',
      multiple_selection: 0,
      start_date: null,
      end_date: null,
      iswallet: 0,


    };
  },

  beforeCreate() {
    let localCart = JSON.parse(localStorage.getItem("cart"));
    if (localCart && localCart != "" && localCart != null && localCart.length > 0) {
      this.$store.commit("product/setCart", localCart);
    }
    let pickupDeliveryFlag = localStorage.getItem("pickupDeliveryFlag");
    if (pickupDeliveryFlag) {
      this.$store.commit("order/pickupdelivery", pickupDeliveryFlag);
    }
  },

  mounted() {

    // let cardTopJson = localStorage.getItem("place_order_data");
    // if (cardTopJson) {
    //   try {
    //     let cardTop = JSON.parse(cardTopJson);
    //     if (cardTop) {
    //       if (cardTop.delivery_instruction) {
    //         this.Instruction = JSON.parse(cardTop.delivery_instruction)
    //         this.Instruction.forEach(instruction => {
    //           this.$set(this.isInstruction, instruction.id, true);
    //         });
    //       }
    //       if (cardTop.driver_tip) {
    //         this.driver_tip = cardTop.driver_tip;
    //         this.is_other_Tip = false;
    //       }
    //       if (cardTop.coupon_redeem) {
    //         this.promocode = cardTop.coupon_redeem;
    //       }
    //       if (cardTop.promo_code_type) {
    //         this.promoCodeType = cardTop.promo_code_type;
    //       }
    //       if (cardTop.cashback) {
    //         this.promoCashback = cardTop.cashback;
    //       }
    //       if (cardTop.promoDiscount) {
    //         this.promoDiscount = cardTop.promoDiscount;
    //       }
    //       if (cardTop.coupon_id) {
    //         this.coupon_id = cardTop.coupon_id;
    //       }
    //       if (cardTop.driver_tip && cardTop.is_other_Tip) {
    //         this.other_driver_tip = cardTop.driver_tip;
    //         this.is_other_Tip = true;
    //       }
    //       if (cardTop && cardTop.autoApplyCode) {
    //         this.autoApplyCode = cardTop.autoApplyCode;
    //       }
    //     }
    //   } catch (error) {
    //     console.error("Error parsing JSON:", error);
    //     // Handle the error as needed
    //   }
    // }

    setTimeout(() => {
      if (this.$auth.user) {
        if (localStorage.getItem('freeCode')) {
          this.freePromocode = localStorage.getItem('freeCode') == 'undefined' ? '' : JSON.parse(localStorage.getItem('freeCode'))
        }
        this.getPrimary()
        this.getSubscriptionData()
        this.checkSubscriptionPromocodeItem()
        // this.getPorterCharges()

        let routeQry = this.$route.query;
        if (routeQry.success) {
          // this.placeOrderId = routeQry.success;
          this.isOrderSuccess = true;
          // window.$(this.$refs.PlaceOrderModal).modal();
        } else if (routeQry.fail) {
          // this.isOrderfail = true; 
        }

        if (this.$auth.setting && typeof this.$auth.setting.delivery_instruction != 'undefined') {
          this.deliveryInstruction = this.$auth.setting.delivery_instruction;
        } else {
          this.deliveryInstruction = [];
        }
        this.isTemplateShow = true;
        this.getRestaurantInfo();
        this.addCartDetails()

        // this.autoApplyPromo()
        this.token = this.$auth.user.token;
        this.userId = this.$auth.user.user_id;
        this.latitude = localStorage.getItem("latitude");
        this.longitude = localStorage.getItem("longitude");
        let currentTime = moment().format(this.timeFormat);
        if (this.$auth.setting) {
          let system_start_time =
            this.$auth.setting && this.$auth.setting.system_start_time != ""
              ? this.$auth.setting.system_start_time.split(" ").pop()
              : "00:00:00";
          let system_end_time =
            this.$auth.setting && this.$auth.setting.system_end_time != ""
              ? this.$auth.setting && this.$auth.setting.system_end_time.split(" ").pop()
              : "23:59:00";
          this.isSameDayDelivery =
            this.$auth.setting && this.$auth.setting.is_same_day_delivery == 0
              ? false
              : true;
          let beforeTime = moment(system_start_time, this.timeFormat);
          let afterTime = moment(system_end_time, this.timeFormat);
          if (moment(currentTime, this.timeFormat).isBetween(beforeTime, afterTime)) {
            this.isAsapEnable = true;
          } else {
            this.isAsapEnable = false;
          }
        }
      } else {
        this.$router.push({ name: "sign-in" });
      }
      if (
        localStorage.getItem("orderUploadImages") != "" &&
        localStorage.getItem("orderUploadImages") != null
      ) {
        let ordImg = [];
        this.images = JSON.parse(localStorage.getItem("orderUploadImages"));
        this.images.forEach((imgid) => {
          ordImg.push(imgid.id);
        });
        this.orderImagesId = ordImg.join(",");
      }
      if (localStorage.getItem("updateAlert")) {
        this.$toasted.success(this.$t("Cart updated"), {
          duration: 2000,
        });
        localStorage.removeItem("updateAlert");
      }
    }, 500);

    if (localStorage.getItem('subscriptionModal_data')) {
      let object = JSON.parse(localStorage.getItem('subscriptionModal_data'));
      this.subscription_type = object.type;
      if (object.type == 1) {
        let everyDay_quantity = object.data[0]
        this.subscriptionData = everyDay_quantity
      }
      if (object.type == 2) {
        object.data.forEach((item) => {
          if (item.isChecked == true) {
            this.getQuantity = item.quantity
          }
        })
      }
      // if (object.type == 2) {
      //   let interval = object.data
      //   this.intervalValue = interval
      // }
      if (object.type == 3) {
        this.selectedDays = object.data
        this.customQuantity = 0
        this.selectedDays.forEach((item) => {
          if (item.isChecked == true && item.quantity > 1) {
            this.customQuantity = item.quantity
          }
        })
      }
      this.day_date_value()
    }
  },

  computed: {
    ...mapGetters("product", ["cart", "getSubscriptionItem", "getSubscription"]),
    ...mapGetters("restaurant", ["restaurantDetails"]),
    ...mapGetters("address", ["addressList", "primaryAddress"]),
    ...mapGetters("order", ["isPickupDelivery"]),
    ...mapGetters("setting", ["getsetting", "getDeliveryZoneSettings"]),
    ...mapGetters("user", ["userWallet"]),

    getCurrentDate() {
      let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
      let day = ("0" + currentDate.getDate()).slice(-2);
      let hours = ("0" + currentDate.getHours()).slice(-2);
      let minutes = ("0" + currentDate.getMinutes()).slice(-2);
      let seconds = ("0" + currentDate.getSeconds()).slice(-2);

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    isBrowser() {
      return typeof window !== 'undefined';
    },

    miniumOrderValue() {
      var value = 0;
      // if (
      //   this.restaurantDetails.minimum_order_value <=
      //   this.$auth.setting.min_order_value
      // ) {
      //   value = this.$auth.setting.min_order_value;
      // } else {
      value = this.restaurantDetails.minimum_order_value;
      // }
      return value;
    },


    activeTabs() {
      const tabs = [];
      // Always show Time tab
      // tabs.push({
      //   id: 'delivery-time-tab',
      //   target: 'delivery-time',
      //   label: this.isPickupDelivery == 1 || this.isPickupDelivery == -1
      //     ? this.$t("Time")
      //     : `${this.$auth.setting.terminology[0].takeaway_text} ${this.$t("Time")}`
      // });

      // Show Tip tab if conditions are met
      if (this.$auth.setting &&
        this.$auth.setting.driver_tip &&
        this.$auth.setting.driver_tip.length > 0 &&
        this.isPickupDelivery == 1) {
        tabs.push({
          id: 'driver-tip-tab',
          target: 'driver-tip',
          label: this.$t("Tip", { msg: this.$auth.setting.driver_name })
        });
      }

      // Show Instruction tab if conditions are met
      if (this.deliveryInstruction != '' && this.isPickupDelivery == 1) {
        tabs.push({
          id: 'delivery-instruction-tab',
          target: 'delivery-instruction',
          label: this.$t("Instruction ", { msg: this.$auth.setting.driver_name })
        });
      }

      return tabs;
    },
    shouldShowTabs() {
      return this.activeTabs.length > 1;
    },



    checkPickupStatus() {
      return this.$auth.setting.is_pickup_enable;
    },
  },
  methods: {
    ...mapActions("product", ["removeProductFromCart"]),
    ...mapActions("address", ["getPrimaryAddress"]),
    ...mapActions("restaurant", [
      "getRestaurantDetails",
      "checkVendorRadius",
      "checkVendorMenuWithPrice",
      "getDunzoQuotationData",
    ]),
    ...mapActions("setting", ["getDeliveryZoneSetting"]),
    ...mapActions("promocode", [
      "promocodeRedeem",
      "updatePromoCode",
      "autoApplyCouponRedeem",
    ]),
    ...mapActions("order", [
      "postUploadOrderImages",
      "postremoveOrderImages",
      "getOrderDistancekm",
      "deliveryZone",
      "getPorterDeliveryCharges",
      "cartDetails", "checkSubscriptionPromocode", "getSubscriptionOrder"
    ]),
    ...mapMutations("product", [
      "decrementProductInventary",
      "IncrementItemQuantity",
      "customizeCartUpdate",
      "clearCartItems",
    ]),
    ...mapMutations("order", ["placeOrderData", "clearPlaceOrderData", "pickupdelivery"]),

    slugify(name) {
      return name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    },
    togglePorterSelection(amount, index) {
      if (this.seletectedPorter == amount && this.activePorterIndex == index) {
        // Unselect if same clicked again
        this.seletectedPorter = null;
        this.activePorterIndex = null;
        this.deliveryCharge = 0;
        this.addCartDetails()
        this.autoApplyCode = false
      } else {
        // Select new
        this.autoApplyCode = false
        this.seletectedPorter = amount;
        this.activePorterIndex = index;
        this.deliveryCharge = amount;
        this.addCartDetails()
      }
    },


    getPrimary() {
      this.getPrimaryAddress().then((response) => {
        this.getPreAddress = response.data;
      })
    },


    addCartDetails(code, id) {
      localStorage.setItem('restaurantId', this.restaurantId)
      let formattedItems = this.getSubscriptionItem.map(item => {
        return {
          item_id: item.item_id,
          // quantity: item.quantity,
          quantity: item.quantity ? item.quantity : quantity,
          customization_ids: item.selectCustoizeID
        };
      });
      let cartScreen = {
        cart_id: '',
        restaurant_id: this.restaurantId,
        latitude: localStorage.getItem("latitude"),
        longitude: localStorage.getItem("longitude"),
        promocode_id: this.coupon_id ? this.coupon_id : id ? this.coupon_id : '',
        promocode: this.promocode ? this.promocode : code ? this.promocode : '',
        is_delivery: this.isPickupDelivery == 1 || this.$auth.setting && this.$auth.setting.is_pickup_enable == false ? true : false,
        tip: this.driver_tip ? this.driver_tip : this.new_driver_tip,
        items: formattedItems,
        is_auto_apply: this.autoApplyCode,
        device_model: 'web',
        // is_porter_delivery: this.$auth.setting && this.$auth.setting.is_active_porter == 'Yes' && this.$auth.setting.porter_delivery_charges == 'Yes' ? true : '',
        is_porter_delivery: this.seletectedPorter ? true : false,
        porter_delivery_charge: this.deliveryCharge ? this.deliveryCharge : ''
      }
      this.cartDetails(cartScreen).then((response) => {
        this.storeCartDetails = response.data;
        this.cart_id = this.storeCartDetails.cart_id;
        let additional_tax = ''
        if (this.storeCartDetails.promo_code && this.storeCartDetails.promo_code.is_free_delivery == true) {
          additional_tax = ''
        } else if (this.storeCartDetails.delivery_charge && this.isPickupDelivery == 1) {
          additional_tax = this.storeCartDetails.additional_tax_on_delivery_charges
        }
        this.others_fees = this.storeCartDetails.tax + this.storeCartDetails.packaging_charge + this.storeCartDetails.convince_charge + this.storeCartDetails.short_order_fee + additional_tax
        // this.others_fees = storeCartDetails.tax + storeCartDetails.convince_charge + this.packagingCharge + storeCartDetails.additional_tax_on_delivery_charges + this.adminComissionValue;
        this.storeCartDetails.items.forEach((item) => {
          this.itemsDetails = item
          if (this.itemsDetails.live_quantity == 0) {
            this.$swal({
              title: 'Clear cart',
              html: 'We are sorry for the inconvenience, some items are out of stock. Please choose another item.',
              confirmButtonText: 'Clear Cart',

            }).then((result) => {
              if (result.isConfirmed) {
                this.cleanCart(); // call your function here
              }
            });
          }
        })


        // auto apply promocode 
        let autoApplycode = this.storeCartDetails.promo_code && this.storeCartDetails.promo_code.code
        this.promoDiscount = this.storeCartDetails.promo_code && this.storeCartDetails.promo_code.discount ? this.storeCartDetails.promo_code.discount : 0
        this.promoCashback = this.storeCartDetails.promo_code && this.storeCartDetails.promo_code.cashback ? this.storeCartDetails.promo_code.cashback : 0
        this.promoSuggetion = this.storeCartDetails.promo_code && this.storeCartDetails.promo_code.auto_apply_suggestion
        if (autoApplycode) {
          this.autoApplyPromocode(autoApplycode, this.promoDiscount)
        }
      })
    },


    SubModals() {
      let data = JSON.parse(localStorage.getItem("subscription_cart"))
      // this.intervalDays = data[0].quantity
      // this.subscription_type = data[0].subscription_type;
      this.subscription_type = this.subscription_type;
      this.subscriptionModalOPen = true;
      // this.day_date_value();
      this.manageSubscriptiopData();
    },

    day_date_value() {
      if (this.subscription_type == 3) {
        this.filterDayValue = (this.selectedDays || []).map((day) => ({
          ...day,
          day: day.day,
          quantity: day.isChecked ? day.quantity : 0,
        }));
      }
      return null;

    },

    closeSubscriptionModal(val) {
      let object = JSON.parse(localStorage.getItem('subscriptionModal_data'))
      this.filterDayValue = object.data
      this.subscriptionModalOPen = false;
      this.intervalDays = JSON.parse(localStorage.getItem("setIntervalday"));
      this.getSubscription[0].quantity = object.data && object.data[0].quantity
    },


    updateSubscriptionItemQuantity(newQuantity) {
      if (this.getSubscriptionItem && this.getSubscriptionItem.length > 0) {
        // Update the quantity in subscription items
        this.getSubscriptionItem.forEach(item => {
          item.quantity = newQuantity;
        });
        // Call cart API with updated quantity
        this.addCartDetails();
      }
    },

    manageSubscriptiopData(val) {
      if (this.subscription_type == 1) {
        this.everyDay_quantity = val;
        // this.addTOSubscription(this.everyDay_quantity[0])
        if (Array.isArray(this.everyDay_quantity) && this.everyDay_quantity.length > 0) {
          this.subscriptionData = this.everyDay_quantity[0];
          localStorage.setItem('subscriptionObj', JSON.stringify(this.subscriptionData))
        }
        this.updateSubscriptionItemQuantity(this.subscriptionData.quantity);
        // this.subscriptionData = this.everyDay_quantity[0];
        // localStorage.setItem('subscriptionObj', JSON.stringify(this.subscriptionData))
      } else if (this.subscription_type == 2) {
        let intervalDate = val;
        const selectedInterval = intervalDate && intervalDate.find(item => item.isChecked == true);
        this.intervalDays = selectedInterval && selectedInterval.value
        this.intervalDays = selectedInterval ? selectedInterval : { quantity: 0, label: '' };
        this.getQuantity = this.intervalDays.quantity
        // this.subscriptionData.quantity = 1
        this.updateSubscriptionItemQuantity(this.getQuantity);
        // localStorage.setItem('intervalDay', JSON.stringify(this.intervalDays));
      } else if (this.subscription_type == 3) {
        this.selectedDays = val;
        // free promocode apply
        this.customQuantity = 0;
        this.selectedDays && this.selectedDays.forEach((item) => {
          if (item.isChecked == true && item.quantity > 1) {
            this.customQuantity = item.quantity
          }
        })
        this.getNexDayQuantity()
        this.day_date_value();
      }
    },

    // getNexDayQuantity(selectedDays) {
    //   const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    //   var todayIndex = new Date().getDay();
    //   // todayIndex = (todayIndex + 1) % 7;
    //   todayIndex = (todayIndex) % 7;

    //   for (let i = 1; i <= 7; i++) {
    //     const nextIndex = (todayIndex + i) % 7;
    //     const nextDay = daysOfWeek[nextIndex];
    //     const nextDayData = this.selectedDays.find((day) => day.key === nextDay);

    //     if (nextDayData && nextDayData.quantity != 0) {
    //       // Update subscription item quantity first
    //       this.updateSubscriptionItemQuantity(nextDayData.quantity);
    //       // Then call addCartDetails (this will be called again in updateSubscriptionItemQuantity, 
    //       // but if you need to pass specific quantity to addCartDetails, you can do it here)
    //       // this.addCartDetails(nextDayData.quantity); // Remove this if not needed since updateSubscriptionItemQuantity calls addCartDetails()

    //       return nextDayData.quantity;
    //     }
    //   }
    //   return 0;
    // },

    getNexDayQuantity(selectedDays) {
      const sub_setting = JSON.parse(localStorage.getItem('subscrption-setting'))
      const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var todayIndex = new Date().getDay();

      // Get current time in HH:MM format
      const now = new Date();
      const currentTime = now.getHours().toString().padStart(2, '0') + ':' +
        now.getMinutes().toString().padStart(2, '0');

      // Check if subscription order place time has passed for today
      const orderPlaceTime = sub_setting && sub_setting.subscription_order_place_at;
      const timeHasPassed = currentTime > orderPlaceTime;

      // If time has passed, start from next day, otherwise start from today
      if (timeHasPassed) {
        todayIndex = (todayIndex + 1) % 7;
      } else {
        todayIndex = (todayIndex) % 7; // This is essentially the same as not modifying it
      }

      for (let i = 1; i <= 7; i++) {
        const nextIndex = (todayIndex + i) % 7;
        const nextDay = daysOfWeek[nextIndex];
        const nextDayData = this.selectedDays.find(day => day.key === nextDay);
        if (nextDayData && nextDayData.quantity != 0) {
          this.updateSubscriptionItemQuantity(nextDayData.quantity);
          return nextDayData.quantity;
        }
      }
      return 0;
    },

    getSubscriptionData() {
      this.subscriptionData = JSON.parse(localStorage.getItem("subscriptionObj"));
      this.intervalDays = JSON.parse(localStorage.getItem("setIntervalday"));
    },

    canSubscribe() {
      // If is_free_order_item is 1, handle the specific conditions
      if (this.freePromocode.is_free_order_item == 1) {
        // Check if intervalDays.quantity > 1 or subscriptionData.quantity > 1
        const intervalExceeds = this.getQuantity > 1;
        const customQuantityExceeds = this.customQuantity > 0;
        const subscriptionExceeds = this.subscriptionData && this.subscriptionData.quantity > 1;

        if (intervalExceeds || subscriptionExceeds || customQuantityExceeds || this.checkPromocodeApply == true) {
          return this.$auth.user && this.$auth.user.data.wallet_amountuserWallet >= this.storeCartDetails.grand_total;
        }
        return true;
      }
      // Default behavior for is_free_order_item != 1
      return this.$auth.user && this.$auth.user.data.wallet_amountuserWallet >= this.storeCartDetails.grand_total;
    },
    freePromocodeModel() {
      $("#freeCoupen").modal("hide");
    },

    freePromocodeOrder() {
      this.isModalConfirmed = true; // Set the modal confirmation state
      this.processToPay(); // Call the payment process again
    },

    checkSubscriptionPromocodeItem() {
      // let itemDetails = JSON.parse(localStorage.getItem('freeCode'))
      if (localStorage.getItem('freeCode')) {
        let itemDetails = localStorage.getItem('freeCode') == 'undefined' ? '' : JSON.parse(localStorage.getItem('freeCode'))
        let checkPromocode = {
          vendor_id: this.$auth.getVendorId(),
          user_id: this.$auth.user.user_id,
          promocode_id: itemDetails.promocode_id,
          item_id: itemDetails.item_id
        }
        if (itemDetails.promocode_id && itemDetails.item_id) {
          this.checkSubscriptionPromocode((checkPromocode)).then((data) => {
            if (data.code == 200) {
              let checkItem = data.result
              this.checkPromocodeApply = checkItem.is_applied
            }
          })
        }
      }
    },

    getSettings() {
      let host = window.location.hostname;
      if (host != '') {
        if (host != 'localhost') {
          this.$auth.setVendorSettings({ order_web: host, latitude: localStorage.getItem("latitude"), longitude: localStorage.getItem("longitude") });
        } else {
          this.$auth.setVendorSettings({ order_web: this.$auth.setting.web_settings && this.$auth.setting.web_settings.website_url, latitude: localStorage.getItem("latitude"), longitude: localStorage.getItem("longitude") });
        }
      }
    },



    //Order Image Upload
    uploadImage(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      let fileSize = selectedFiles[0].size / 1024 / 1024;
      if (fileSize <= 1) {
        var formData = new FormData();
        var totalImg = selectedFiles.length + this.images.length;
        if (totalImg > this.$auth.setting.order_image_upload_limit) {
          this.$toasted.error(
            this.$t(
              "You can add maximum " +
              this.$auth.setting.order_image_upload_limit +
              " photos"
            ),
            { duration: 2000 }
          );
        } else {
          this.loading = true;
          this.is_btn_spinner = true;
          for (let i = 0; i < selectedFiles.length; i++) {
            // formData.append("image[" + i + "]", selectedFiles[i]);
            formData.append("image", selectedFiles[i]);
          }
          this.postUploadOrderImages(formData).then((response) => {
            if (response.status == true) {
              let imagesArray = response.data
              if (
                localStorage.getItem("orderUploadImages") != "" ||
                localStorage.getItem("orderUploadImages") != null
              ) {
                this.images.push(imagesArray);
              } else {
                this.images.push(imagesArray);
              }
              localStorage.setItem("orderUploadImages", JSON.stringify(this.images));
              let ordImg = [];
              this.images.forEach((imgid) => {
                ordImg.push(imgid.id);
              });
              this.orderImagesId = ordImg.join(",");
              this.loading = false;
              this.is_btn_spinner = false;
            } else {
              this.is_btn_spinner = false;
              this.loading = false;
            }
          });
        }
      } else {
        this.$toasted.error(this.$t("File too Big, please select a file less than 1mb"), {
          duration: 2000,
        });
      }
    },

    //Remove uplod image from
    removeUploadImage(id) {
      this.$swal({
        title: this.$t("Are you sure you want to delete?"),
        type: "warning",
        customClass: {
          confirmButton: "cofirm-btn-new",
          cancelButton: "cancle-btn-new",
          title: "clear-cart-text mt-3 mb-1",
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.is_btn_spinner = true;
          this.postremoveOrderImages({
            id: id,
          }).then((response) => {
            if (response.status == true) {
              localStorage.setItem("orderUploadImages", "");
              let ordImg = [];
              this.orderImagesId = "";
              var rIndex = this.images.findIndex((r) => r.id == id);
              this.images.splice(rIndex, 1);
              this.images.forEach((imgid) => {
                ordImg.push(imgid.id);
              });
              localStorage.setItem("orderUploadImages", JSON.stringify(this.images));
              this.orderImagesId = ordImg.join(",");
              this.loading = false;
              this.is_btn_spinner = false;
            }
          });
        }
      });
    },


    //Increament Item
    plusItem(item, index) {
      this.autoApplyCode = false
      //const cartItemIndex = this.cart.findIndex(itm => parseInt(itm.item_id) === parseInt(item.item_id));
      let cartItem = { cartItemIndex: index, product: item };
      if (item.itemTotalQuantity > item.quantity) {
        this.$store.commit("product/IncrementItemQuantity", cartItem);
        this.$nextTick(() => {
          this.addCartDetails();
        });
        this.isPopup = false;
      } else {
        alert(this.$t("Maximum items reached"));
      }
      if (this.applyPromoCodeResult) {
        // this.applyPromocodeByItem();
      }
    },

    //Decrement Item
    minusItem(cartProduct, index) {
      if (cartProduct.quantity == "1" || cartProduct.quantity == "0") {
        this.deleteProduct(index);
      } else {
        this.isPopup = false;
        this.autoApplyCode = false
        this.$store.commit("product/decrementProductInventary", index);
        this.$nextTick(() => {
          this.addCartDetails();
        });
      }
      if (this.applyPromoCodeResult) {
        // this.applyPromocodeByItem();
      }
    },

    deleteProduct(index) {
      this.$store.commit("order/clearPlaceOrderData");
      this.$store.dispatch("product/removeProductFromCart", index);
    },







    // ========================================================================================================================================================================================================================




    openImagePreview(image, name) {
      this.selectedImage = image;
      this.itemName = name;
    },

    encodeBase64(value) {
      // Ensure window.btoa is available
      return this.isBrowser ? window.btoa(value) : '';
    },
    //save your item price
    savedPrice() {
      let savemrpTotal = 0;
      let savemrp = 0;
      this.cart.forEach((item) => {
        if (item.price < item.mrp) {
          savemrp = item.mrp - item.price;
          savemrpTotal += savemrp * item.quantity;
        }
      });
      return savemrpTotal;
    },
    redirectBillingData() {
      var myDiv = document.getElementById("billing-data");
      var offsetTop = myDiv.offsetTop;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    },
    deliveryModalOpen() {
      // localStorage.getItem('selectedIndex')
      this.selectedIndex = this.shiping_id
      this.driver_tip = 0;
      this.promocode = "";
      // this.promoSuggetion = "";
      this.isPromocodeApply = false;
      this.promoDiscount = 0;
      this.promoCashback = 0;
      // this.promocodeType = 0;
      // localStorage.removeItem('promocodeType');
      $(".location-modal").addClass("heightModal");
      $("#deliveryModal").modal("show");
    },

    openImg(element) {
      this.imageUrl = element.image;
      $("#imgOpen").modal("show");
    },

    //Item Text Display
    itemTexDisplay() {
      let itemTex = 0;
      this.cart.forEach((item) => {
        itemTex += item.item_tax * item.quantity;
      });
      return itemTex.toFixed(2);
    },

    // auto apply promocode by defult apply code

    //Promocode modal
    promocodeModal() {
      localStorage.removeItem("place_order_data");
      // localStorage.removeItem('promocodeType');
      this.latitude = localStorage.getItem("latitude");
      this.longitude = localStorage.getItem("longitude");
      this.promoCodes = [];
      // this.promocode = ""
      // let deliveryType = "Delivery";
      // if (this.isPickupDelivery == 1 || this.isPickupDelivery == -1) {
      //   deliveryType = "Delivery";
      // } else {
      //   deliveryType = "Pickup";
      // }
      this.updatePromoCode({
        delivery_type: this.isPickupDelivery,
        restaurant_id: localStorage.getItem('restaurantId'),
        latitude: this.latitude,
        longitude: this.longitude,
        // user_id: this.userId,
        // cityname: localStorage.getItem("city"),
      }).then((response) => {
        if (response.status == true) {
          this.promoCodes = response.data;
          // coupon_id = this.data.Result.coupon_id
          this.promoCodeType = 0;
        }
        $("#promocodeModal").modal("show");
      });
    },

    onSetOrderTime(value) {
      this.scheduleDateTime = value;
    },

    async getAddress(lat1, lon1, lat2, lon2,) {
      // localStorage.removeItem('promocodeType'); 
      this.selectedIndex = this.id
      this.getSettings()
      this.addCartDetails()
      if (this.primaryAddress && this.primaryAddress.is_delivery_zone_active == false) {
        this.$swal({
          title: this.$auth.setting.app_name,
          html: 'Sorry, At this moment we are not providing delivery service at your selected location.<br> <b>Please change address</b>',
        });
        return true;
      }

      if (Object.keys(this.primaryAddress).length > 0) {
        this.is_btn_spinner = false;
        this.address =
          this.primaryAddress.flat_no +
          " " +
          this.primaryAddress.house_name +
          " " +
          this.primaryAddress.address;
        this.shiping_id = this.primaryAddress.id;
        // await this.getDeliveryChrge();
        // this.autoApplyPromo()
      } else {
        this.address = "";
        this.is_btn_spinner = false;
      }
      if (
        Object.keys(this.primaryAddress).length == 0 ||
        this.primaryAddress.deliveryAddress == ""
      ) {
        this.$router.push({ name: "add-address" });
        // this.deliveryModalOpen();
        // // if(this.addressList.length > 0){
        // // }else{
        // }
      }
    },

    //Get Restaurant Information
    getRestaurantInfo() {
      // if (this.cart.length) {
      this.restaurantId = localStorage.getItem('restaurantId');
      this.getRestaurantDetails({
        params: {
          restaurant_id: this.restaurantId,
          latitude: localStorage.getItem('latitude'),
          longitude: localStorage.getItem('longitude')
        }
      }).then((response) => {
        if (response.status == true) {
          this.restaurantData = response.data;
          this.restaurantId = this.restaurantData.id;
          this.restaurant_service_tax = response.data.restaurant_service_tax;
          this.restaurantLat = response.data.latitude;
          this.restaurantLong = response.data.longitude;
          this.instructionPlaceholder =
            this.$t("Any special request for ") + "Outlet";
          this.isRestaurantClosed = response.data.is_restaurant_on == false ? false : true;
          // this.getDeliveryChrge();
        }
      });
      // }
    },

    //Display Total Amount Of item cart
    getTotalItemPrice(item) {
      return item.price * item.quantity;
    },

    //Get Total Amount of Items
    // getTotalItemAmount() {
    //   let itmTotal = 0;
    //   let itemCount = 0;
    //   let packCharge = 0;
    //   this.cart.forEach((item) => {
    //     itmTotal += item.price * item.quantity;
    //     itemCount++;
    //     packCharge += item.packaging_charge * item.quantity;
    //   });
    //   let restPackCharge = 0;
    //   if (
    //     this.restaurantData.restaurant_packaging_type &&
    //     this.restaurantData.restaurant_packaging_type == "fixed" &&
    //     this.restaurantData.restaurant_packaging_charge > 0
    //   ) {
    //     restPackCharge = parseFloat(this.restaurantData.restaurant_packaging_charge);
    //   } else if (
    //     this.restaurantData.restaurant_packaging_type &&
    //     this.restaurantData.restaurant_packaging_type == "percentage" &&
    //     this.restaurantData.restaurant_packaging_charge > 0
    //   ) {
    //     restPackCharge = parseFloat(
    //       parseFloat(
    //         ((itmTotal / 100) * this.restaurantData.restaurant_packaging_charge).toFixed(
    //           2
    //         )
    //       )
    //     );
    //   }
    //   this.packagingCharge = packCharge + restPackCharge;
    //   this.cartItemCount = itemCount;
    //   return this.$formatPrice(itmTotal);
    //   //return parseFloat(itmTotal).toFixed(2);
    // },



    //Remove Item from cart

    getPorterCharges() {
      // let clntLatlng = this.primaryAddress;
      // let restLatlng = this.restaurantDetails;
      if (this.$auth.setting && this.$auth.setting.is_active_porter == true) {
        this.getPorterDeliveryCharges({
          pickup_latitude: localStorage.getItem("storelat"),
          pickup_longitude: localStorage.getItem("storelng"),
          drop_latitude: localStorage.getItem("latitude"),
          drop_longitude: localStorage.getItem("longitude")
        }).then((response) => {
          if (response.status == true) {
            this.porterCharges = response.data
            if (this.isPickupDelivery == 1 && this.$auth.setting && this.$auth.setting.is_active_porter == false && this.$auth.setting.porter_delivery_charges == true) {
              this.deliveryCharge = 0
              this.showPorterChrages = true
              // $("#portalModal").modal("show");
            }
          } else if (response.code == 101) {
            // $("#portalModal").modal("hide");
            this.showPorterChrages = false
            this.deliveryCharge = 0
          }

        })
      }
    },


    //Remove Apply Code
    removePromocode() {
      this.autoApplyCode = false
      localStorage.removeItem("place_order_data");
      localStorage.removeItem("promocodeType");
      this.promocode = "";
      this.promoSuggetion = "";
      this.isPromocodeApply = false;
      this.promoDiscount = 0;
      this.promoCashback = 0;
      this.promoCodeType = 0;
      this.addCartDetails()
    },

    comapreDate(d1, d2) {
      let dateTime1 = new Date(d1);
      let dateTime2 = new Date(d2);

      let time1 =
        dateTime1.getHours() * 60 * 60 * 1000 +
        dateTime1.getMinutes() * 60 * 1000 +
        dateTime1.getSeconds() * 1000 +
        dateTime1.getMilliseconds();
      let time2 =
        dateTime2.getHours() * 60 * 60 * 1000 +
        dateTime2.getMinutes() * 60 * 1000 +
        dateTime2.getSeconds() * 1000 +
        dateTime2.getMilliseconds();
      if (time1 < time2) {
        return true;
      } else {
        return false;
      }
    },


    checkEmailBeforeProceed() {
      // Check if the user's email is null
      if (this.$auth.user.user_email == null) {
        // Show SweetAlert modal asking for an email address
        this.$swal({
          title: 'Add Your Email Address',
          html: "Please provide your email address. This will help us keep you informed about your order status, delivery details, and any special offers.",
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to profile page if Yes is clicked
            this.$router.push({ name: 'profile' });
          } else if (result.dismiss == this.$swal.DismissReason.cancel) {
            // No action needed when canceled, but it should prevent proceeding
          }
        });
        return false; // Prevents further execution
      }
      return true; // Email exists, allow further execution
    },

    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },





    async processToPay() {
      //if email not exist then redirect for profile page

      // if (this.userWallet < this.getTotalAmount() && this.subscriptionData && (this.subscriptionData.quantity > 1 || this.getQuantity > 1 || this.customQuantity > 0)) {
      //   Vue.toasted.error("Insufficient wallet amount please recharge your wallet", {
      //     duration: 2000,
      //   });
      //   return;
      // }

      if (this.freePromocode.is_free_order_item == 1) {
        if (this.subscriptionData && !this.isModalConfirmed && (this.checkPromocodeApply == true || this.subscriptionData.quantity > 1 || this.getQuantity > 1 || this.customQuantity > 0)
        ) {
          // Show the modal if quantity is greater than 1
          $("#freeCoupen").modal("show");
          return;
        }
        this.isModalConfirmed = false;
      }
      if (this.$auth.user && this.$auth.user.data && this.$auth.user.data.email == null && !this.emailPromptDismissed) {
        this.$swal({
          title: 'Add Your Email Address',
          html: "Please provide your email address. This will help us keep you informed about your order status, delivery details, and any special offers.",
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to profile page if Yes is clicked
            this.$router.push({ name: 'profile' });
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.emailPromptDismissed = true; // Set the flag when No is clicked
            // this.$router.push({ name: 'payment' });
          }
        });
        return true;
      }
      if (this.$auth.setting && this.$auth.setting.is_active_porter == true && this.$auth.setting.porter_delivery_charges == true && this.seletectedPorter == 0 && this.isPickupDelivery == 1) {
        this.$toasted.error(this.$t("Please Select Your Delivery Option"), {
          duration: 2000,
        });
        return false;
      }





      let itemDetailsArray = [];
      let itemDetails = {};
      this.getSubscriptionItem.forEach((item) => {
        let singleSelection = "";
        // let multiple_selection = "";

        this.start_date = item.start_date;
        this.end_date = item.end_date;
        this.subscription_type = item.subscription_type;
        this.interval = item.interval;
        // this.custom_days = item.custom_days;
        this.custom_days = item.custom_days;
        this.multiple_selection = item.selectCustoizeID
        itemDetails = {
          item_id: item.item_id,
          single_selection: singleSelection,
          is_bravges: "0",
          multiple_selection: this.multiple_selection,
          quantity: item.quantity,
          packaging_charge: parseFloat(this.storeCartDetails && this.storeCartDetails.packaging_charge).toFixed(2),
        };
        itemDetailsArray.push(itemDetails);
      });
      let costumDays = JSON.parse(localStorage.getItem('subscribe-custom'));
      this.place_order_parameter = {
        cart_id: this.cart_id,
        address_id: this.primaryAddress.id,
        contact_less_delivery: 0,
        notes: this.instructions,
        interval: this.subscription_type === 1 || this.subscription_type === 3 ? this.interval : this.intervalDays.value,
        custom_days: this.subscription_type === 3 ? JSON.stringify(costumDays) : "",
        start_date: this.start_date,
        end_date: this.end_date,
        payment_method: "Wallet",
        payment_type: "wallet",
        subscription_type: this.subscription_type,
        single_selection: [],
        multiple_selection: this.multiple_selection,
        device_type: 'Web',
        app_version_code: '',
        delivery_instruction: this.deliveryInstructionValues,
        // delivery_type: this.isPickupDelivery,
        // future_delivery_date: future_delivery_date,
        // payment_type: '',
        // suggestion: '',
        // delivery_pickup_types: this.isPickupDelivery == 1 ? "Delivery" : "Pickup",
        // wallet_amount: 0.0,
        // remaining_amount: this.storeCartDetails.grand_total,
      };
      this.$store.dispatch("order/placeOrderData", this.place_order_parameter);
      localStorage.setItem("place_order_data", JSON.stringify(this.place_order_parameter));

      // this.$store.dispatch("order/placeOrderData", this.place_order_parameter);
      // console.log(this.place_order_parameter, "this.place_order_parameter")
      // this.$store.commit("product/customizeCartUpdate", true);
      await this.checkRestaurantRadius();

      this.getSubscriptionOrder((this.place_order_parameter)).then((data) => {
        if (data.status == true) {
          this.isOrderSuccess = true;
        }
      })

    },
    checkRestaurantRadius() {
      let vm = this;
      this.checkVendorRadius({
        latitude:
          this.primaryAddress.latitude && this.isPickupDelivery == 1
            ? this.primaryAddress.latitude
            : parseFloat(localStorage.getItem("latitude")),
        longitude:
          this.primaryAddress.longitude && this.isPickupDelivery == 1
            ? this.primaryAddress.longitude
            : parseFloat(localStorage.getItem("longitude")),
        restaurant_id: this.restaurantId,
      })
        .then((response) => {
          if (response.status == true) {
            this.$refs.redirectPayment.$el.click();
            // this.checkRestaurantMenuWithPrice();
          } else if (this.restaurantDetails.restaurant_on_off == null) {
            this.$swal({ title: this.$t("This Restaurant is closed") });
            this.is_btn_spinner = false;
            return false;
          } else {
            this.$swal({
              title: this.$t("Oops! We do not deliver at your selected location "),
            });
            this.is_btn_spinner = false;
            return false;
          }
        }).finally(() => {
          this.is_btn_spinner = false;
        })
      // .catch(function () {
      //   vm.$swal({ title: vm.$t("Something went wrong, Please try again") });
      //   vm.is_btn_spinner = false;
      //   return false;
      // });
    },

    // checkRestaurantMenuWithPrice() {
    //   let menu_item_ids = [];
    //   let menu_item_price = [];
    //   let customisation_menu_item_ids = [];
    //   let customisation_menu_item_price = [];
    //   let menu_item_quantity = [];
    //   let item_packaging_charge = [];

    //   this.cart.forEach((item) => {
    //     menu_item_ids.push(item.item_id);
    //     menu_item_price.push(item.item_price);
    //     menu_item_quantity.push(item.quantity);
    //     item_packaging_charge.push(item.packaging_charge);
    //     if (item.selected_type.length) {
    //       customisation_menu_item_ids.push(item.selectCustoizeID);
    //       customisation_menu_item_price.push(item.selectCustoizePrice);
    //     }
    //   });
    //   let postdata = {
    //     is_langauge: this.$store.state.lang.locale,
    //     vendor_id: this.$auth.getVendorId(),
    //     restaurant_id: this.restaurantId,
    //     menu_item: menu_item_ids.join(),
    //     item_price: menu_item_price.join(),
    //     customisation_id: customisation_menu_item_ids.join(),
    //     customisation_price: customisation_menu_item_price.join(),
    //     item_quantity: menu_item_quantity.join(),
    //     beverage_ids: "",
    //     packaging_charge: item_packaging_charge.join(),
    //   };
    //   this.checkVendorMenuWithPrice(postdata).then((data) => {
    //     if (data.code == 200) {
    //       this.is_btn_spinner = false;
    //       this.$store.dispatch("order/placeOrderData", this.place_order_parameter);
    //       localStorage.setItem(
    //         "place_order_data",
    //         JSON.stringify(this.place_order_parameter)
    //       );
    //       this.$refs.redirectPayment.$el.click();
    //     } else if (data.code == 205) {
    //       this.is_btn_spinner = false;
    //       data.Result.forEach((updateData) => {
    //         const cartindex = this.cart.findIndex(
    //           (item) => parseInt(item.item_id) === parseInt(updateData.item_id)
    //         );
    //         let itemTax = 0;
    //         if (updateData.quantity == 0) {
    //           this.cart.splice(cartindex, 1);
    //         } else {
    //           if (updateData.item_tax != "0") {
    //             itemTax =
    //               updateData.price - updateData.price / (1 + updateData.item_tax / 100);
    //           }
    //           this.cart[cartindex].item_tax = itemTax;
    //           this.cart[cartindex].item_price = updateData.price;
    //           this.cart[cartindex].mrp = updateData.mrp;
    //           this.cart[cartindex].packaging_charge = parseFloat(
    //             updateData.packaging_charge
    //           );
    //           if (updateData.quantity < this.cart[cartindex].quantity) {
    //             this.cart[cartindex].quantity = updateData.quantity;
    //             this.cart[cartindex].itemTotalQuantity = updateData.quantity;
    //           }
    //         }
    //       });
    //       /****Customization****/
    //       if (data.customisation.length > 0) {
    //         this.cart.forEach((item, i) => {
    //           data.customisation.forEach((customis) => {
    //             const cartcustindex = item.selectCustoizeID.findIndex(
    //               (itmcust) => parseInt(itmcust) === parseInt(customis.customisation_id)
    //             );
    //             this.cart[i].selectCustoizePrice[cartcustindex] = customis.price;
    //           });
    //         });
    //       }
    //       this.$store.commit("product/customizeCartUpdate", true);
    //       this.$toasted.success(this.$t("Cart updated"), { duration: 3000 });
    //     } else {
    //       this.is_btn_spinner = false;
    //       alert(data.msg);
    //     }
    //   });
    // },

    goToHome() {
      this.$router.go(-1);
    },



    /**
     * Cart clear for function.
     */
    cleanCart() {
      this.$swal({
        title: this.$t("Are you sure you want to clear cart?"),
        type: "warning",
        customClass: {
          confirmButton: "cofirm-btn-new",
          cancelButton: "cancle-btn-new",
          title: "clear-cart-text mt-3 mb-1",
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      }).then((result) => {
        // <--
        if (result.isConfirmed) {
          // <-- if confirmed
          localStorage.setItem("driverTip", (this.driver_tip = 0));
          this.$store.commit("product/clearCartItems");
          localStorage.removeItem("place_order_data");
          localStorage.removeItem("orderUploadImages");
        }
      });
    },

    readMore(value) {
      $("#moredesc" + value).toggle(400);
      $("#shortdec" + value).toggle(400);
    },

    getDelivery(value) {
      let data = this.isPickupDelivery
      if (localStorage.getItem("pickupDeliveryFlag") == value) {
        return false;
      }
      if (value == 0 || value == "0") {
        this.deliveryCharge = 0;
        this.deliveryChargeTax = 0
      }

      this.$store.commit("order/pickupdelivery", value);
      localStorage.setItem("pickupDeliveryFlag", value);
      this.removePromocode();
      // this.getDeliveryChrge();
      // this.addCartDetails()
    },

    floatNumberOnly(evt) {
      let val1 = evt.target.value;
      if (!(evt.keyCode == 46 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
        evt.preventDefault();
      }
      let partlen = val1.split(".").length - 1;
      if (evt.keyCode == 46 && partlen == 1) {
        evt.preventDefault();
      }
    },

    tipModal() {
      if (this.driver_tip > 0) {
        this.driver_tip = 0;
      }
      $("#driverTipModal").modal("show");
    },

    otherFeesModal() {
      $("#otherFeesModal").modal("show");
    },
    // portalModalOpen() {
    //   $("#portalModal").modal("show");
    // },

    closeTexModal() {
      $("#otherFeesModal").modal("hide");
      $("#portalModal").modal("hide");
    },

    closeTipModal(id) {
      this.autoApplyCode = false
      // this.other_driver_tip = document.getElementById('tripValue').value;
      if (this.other_driver_tip > 0) {
        this.is_other_Tip = true;
        this.new_driver_tip = this.other_driver_tip;
        this.addCartDetails()
        $("#tip_other").prop("checked", true);
        $("#tip_other").addClass("active");
        $("#driverTipModal").modal("hide");
        this.radioCounts = 1;
        // localStorage.setItem("new_driver_tip", JSON.stringify({ id: "tip_other", value: this.new_driver_tip }));
      } else {
        this.$toasted.error(this.$t("Please enter proper amount"), {
          duration: 3000,
        });
      }
    },

    getTipValue(value, type, id) {
      this.autoApplyCode = false
      if (type == "other_driver_tip") {
        this.tipsClick = [];
        if (this.radioCounts == 1) {
          $("#tip_other").prop("checked", false);
          this.new_driver_tip = 0;
          this.radioCounts = 0;
          this.addCartDetails()
        } else {
          $("#tip_other").prop("checked", true);
          this.tipsClick.push(id);
          this.new_driver_tip = value;
          this.radioCounts = 1;
          // this.addCartDetails()
        }
        this.autoApplyCode = false
        this.driver_tip = 0;
        this.addCartDetails()
      } else {
        // this.other_driver_tip = '';
        this.radioCounts = 0;
        if (this.tipsClick.includes(id)) {
          var index = this.tipsClick.indexOf(id);
          if (index !== -1) {
            this.tipsClick.splice(index, 1);
          }
          $("#tip_" + id).prop("checked", false);
          this.driver_tip = 0;
          this.addCartDetails()
        } else {
          this.autoApplyCode = false
          this.is_other_Tip = false;
          this.tipsClick = [];
          this.tipsClick.push(id);
          this.driver_tip = value;
          this.addCartDetails()
        }
        this.new_driver_tip = 0;
      }
    },


    // get delivery instruction checked this function
    getDeliveryInstruction(value, type, id) {
      const index = this.Instruction.findIndex(instruction => instruction.id === id);
      if (index !== -1) {
        this.Instruction.splice(index, 1);
        this.$set(this.isInstruction, id, false);
      } else {
        this.Instruction.push({ id: id, value: value });
        this.$set(this.isInstruction, id, true);
      }
      this.deliveryInstructionValues = this.Instruction.map(item => item.value).join(',');
      //localStorage.setItem('selectedInstruction', JSON.stringify(this.Instruction));
    },

    cancelTipModal(val) {
      // localStorage.removeItem("new_driver_tip")
      // document.getElementById('tripValue').value = null;
      $("#driverTipModal").modal("hide");
      this.other_driver_tip = val;
      if (this.other_driver_tip == 0) {
        this.is_other_Tip = false;
        this.new_driver_tip = 0;
        // this.other_driver_tip = "";
        $("#tip_other").prop("checked", false);
        $("#tip_other").removeClass("active");
      } else {
        this.new_driver_tip = this.other_driver_tip;
        $("#tip_other").prop("checked", true);
      }
    },
  },
};
</script>

<style scoped>
.svprc {
  padding: 0 15px;
  background: #27ae60;
  margin: 0 -15px;
  color: #fff;
}

.svprc p {
  padding: 7px;
}

.delivery-address {
  padding: 15px;
  position: sticky;
}

.delivery-address .delivery-pickup-main {
  display: inline-flex !important;
}

.delivery-address .delivery-nw-section {
  display: contents;
}

.delivery-nw-section span {
  margin-right: 30px;
  font-weight: 500;
}

.delivery-nw-section .chng-addrs {
  margin-left: 24px;
}

.pckup-addr-cls .pickup-txt {
  margin-right: 32%;
  font-weight: 500;
}

button.btn.btn-primary.disabled,
.prcc-cls-blr,
.prcc-cls,
.prcc-cls:hover,
.prcc-cls-blr:hover {
  background: #27ae60;
  border: none;
}

.delivery-address p {
  white-space: unset;
  width: 100%;
  overflow: unset;
}

@media only screen and (max-width: 767px) {
  .delivery-address p {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }

  .pckup-addr-cls .pickup-txt {
    margin-right: 12%;
  }

  .delivery-pickup-main .delivery-pickup-lnk {
    width: 146px;
  }

  .delivery-nw-section span {
    font-size: 12px;
    margin-right: 0;
  }

  .delivery-nw-section .chng-addrs {
    margin-left: 1px;
    font-size: 12px;
  }
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-top: 20px;
  cursor: pointer;
}

.card-title {
  font-size: 12px;
}

.option-card {
  border: 1px solid var(--secondary-gray);
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
}



.option-card img {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

.option-card h5 {
  font-size: 12px;
}

.option-card p {
  margin: 0 0;
  font-size: 12px;
  color: #555;
}



button {
  margin-top: 10px;
  padding: 10px 15px;
  font-size: 16px;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.vehicle-name {
  padding: 0;
}

.option-card.card.active-border {
  border-color: rgba(var(--theme-primary));
  color: var(--theme-font-primary);
  /* Active border color */
}

.cust-porter-btn.active-border {
  border-color: rgba(var(--theme-primary));
  color: rgba(var(--theme-primary));
}

.cust-porter-btn.active-border p {
  border-color: rgba(var(--theme-primary));
  color: rgba(var(--theme-primary));
}

@media (max-width: 600px) {
  .options-grid {
    grid-template-columns: 1fr;
  }
}

.date-list {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 3px;
}

.date-item {
  background-color: #e9e9e9;
  border-radius: 10px;
  min-width: 50px;
  text-align: center;
  font-size: 14px;
}

.date-day {
  background-color: rgba(var(--theme-primary));
  color: #fff;
  padding: 6px;
  border-radius: 10px;
  width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.date-num {
  padding: 6px;
}

.disabled-link {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}

.free-coupen {
  height: 25vh;
}
</style>
